import React, {  Component } from 'react';

export default class confirmCancelLineOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("confirmCancelLineOverlayDialog", false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Confirm Cancel</h2>
					<p>Are you sure you want to cancel this order line?</p>
                    <p>It may take up to 30 min. for changes to be reflected in CustomerNet.</p>
                    <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
					<a className="blueButton yesButton" onClick={this.props.handleCancel}>Yes</a>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmCancelLineOverlayDialog.js